<app-pagetitle title="Assinatura de documentos" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="col-12 mb-4">
    <form [formGroup]="documentForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura Principal (<span style="color: red;">obrigatório</span>)</h4>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="nomeAssinaturaPrincipal">Nome Completo</label>
                                    <input formControlName="nomeAssinaturaPrincipal" type="text"
                                        class="form-control form-control-sm" placeholder="Nome" [ngClass]="{
                                            'is-invalid':
                                            documentForm.controls.nomeAssinaturaPrincipal.errors &&
                                            documentForm.get('nomeAssinaturaPrincipal')?.touched,
                                          }">
                                    <div class="invalid-feedback"
                                        *ngIf="documentForm.controls.nomeAssinaturaPrincipal.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="emailAssinaturaPrincipal">E-mail</label>
                                    <input formControlName="emailAssinaturaPrincipal" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail" [ngClass]="{
                                            'is-invalid':
                                            documentForm.controls.emailAssinaturaPrincipal.errors &&
                                            documentForm.get('emailAssinaturaPrincipal')?.touched,
                                          }">
                                    <div class="invalid-feedback"
                                        *ngIf="documentForm.controls.emailAssinaturaPrincipal.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="documentoAssinaturaPrincipal">CPF</label>
                                    <input formControlName="documentoAssinaturaPrincipal" type="text"
                                        class="form-control form-control-sm" placeholder="CPF" [ngClass]="{
                                            'is-invalid':
                                            documentForm.controls.documentoAssinaturaPrincipal.errors &&
                                            documentForm.get('documentoAssinaturaPrincipal')?.touched,
                                          }"
                                          mask="000.000.000-00">
                                    <div class="invalid-feedback"
                                        *ngIf="documentForm.controls.documentoAssinaturaPrincipal.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <label for="tipoAssinaturaPrincipal">Tipo de assinatura:</label>
                            <div class="form-check col-md-4 mb-3">
                                <input style="opacity: inherit;" formArrayName="tipoAssinaturaPrincipal" class="form-check-input" type="checkbox"
                                    checked value="1" id="tipoAssinaturaPrincipal" required [checked]="true"
                                    [disabled]="true">
                                    <div class="d-flex">

                                        <label class="form-check-label" for="invalidCheck">
                                            Assinatura
                                        </label>
                                        <div>

                                            <span
                                            ngbTooltip="Esse é o tipo mais comum de assinatura. Representa a concordância formal do signatário com o conteúdo do documento."
                                            class="badge rounded-pill bg-warning ms-1">Info</span>
                                        </div>
                                    </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- end card -->
            </div> <!-- end col -->
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura</h4>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="nomeAssinatura02">Nome Completo</label>
                                    <input formControlName="nomeAssinatura02" type="text"
                                        class="form-control form-control-sm" placeholder="Nome">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="emailAssinatura02">E-mail</label>
                                    <input formControlName="emailAssinatura02" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="documentoAssinatura02">CPF</label>
                                    <input formControlName="documentoAssinatura02" type="text"
                                        class="form-control form-control-sm" placeholder="CPF"
                                        mask="000.000.000-00">
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <label for="validationCustom02">Tipo de assinatura:</label>

                            <div class="form-check col-md-5 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked2(4)"
                                    (change)="selecionarTipo2(4)" id="comoParte2" />
                                <label class="form-check-label" for="comoParte2">Como parte <span
                                    ngbTooltip="Também envolve a assinatura formal do documento, mas com ênfase de que o signatário é uma das partes principais do contrato."
                                    class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>

                            <div class="form-check col-md-5 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked2(5)"
                                    (change)="selecionarTipo2(5)" id="testemunha2" />
                                <label class="form-check-label" for="testemunha2">Testemunha <span
                                    ngbTooltip="A pessoa assina o documento somente para atestar que presenciou a assinatura das partes principais."
                                    class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="nomeAssinatura03">Nome Completo</label>
                                    <input formControlName="nomeAssinatura03" type="text"
                                        class="form-control form-control-sm" placeholder="Nome">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="emailAssinatura03">E-mail</label>
                                    <input formControlName="emailAssinatura03" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="documentoAssinatura03">CPF</label>
                                    <input formControlName="documentoAssinatura03" type="text"
                                        class="form-control form-control-sm" placeholder="CPF"
                                        mask="000.000.000-00">
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <label for="validationCustom02">Tipo de assinatura:</label>

                            <div class="form-check col-md-5 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked3(4)"
                                    (change)="selecionarTipo3(4)" id="comoParte3" />
                                <label class="form-check-label" for="comoParte3">Como parte<span
                                    ngbTooltip="Também envolve a assinatura formal do documento, mas com ênfase de que o signatário é uma das partes principais do contrato."
                                    class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>

                            <div class="form-check col-md-5 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked3(5)"
                                    (change)="selecionarTipo3(5)" id="testemunha3" />
                                <label class="form-check-label" for="testemunha3">Testemunha<span
                                    ngbTooltip="A pessoa assina o documento somente para atestar que presenciou a assinatura das partes principais."
                                    class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>
                        </div>

                        <!-- <div class="row">
                            <div class="col-xl-6">

                                <div class="form-group">
                                    <label class="form-label" for="contato">Documento para assinar</label>
                                    <input 
                                        type="file"
                                        formControlName="document"
                                        class="form-control" 
                                        (change)="onChange($event)"
                                        accept=".pdf"
                                    />
                                    <div style="color: red;"
                                    *ngIf="documentForm.get('document')?.invalid &&
                                        documentForm.get('document')?.touched">
                                        Um documento deve ser selecionado
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <!-- end card -->
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Documento (<span style="color: red;">obrigatório</span>)</h4>
                    </div>
                    <div class="card-body">
                        <div class="col-xl-6">

                            <div class="form-group">
                                <label class="form-label" for="contato">Documento para assinar</label>
                                <input type="file" formControlName="document" class="form-control"
                                    (change)="onChange($event)" 
                                    accept=".pdf" 
                                    [ngClass]="{
                                        'is-invalid':
                                        documentForm.controls.document.errors &&
                                        documentForm.get('document')?.touched,
                                      }"/>
                                <div style="color: red;" *ngIf="documentForm.get('document')?.invalid &&
                                    documentForm.get('document')?.touched">
                                    Um documento PDF deve ser selecionado.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-5 d-flex">
                <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
                <button type="submit" class="btn btn-info waves-effect waves-light d-flex">
                    <i class="mdi mdi-pencil d-block font-size-16 me-3"></i> Solicitar Assinaturas
                </button>

                <!-- <button type="button" class="btn btn-danger waves-effect waves-light d-flex">
                    <i class="mdi mdi-trash-can d-block font-size-16 me-3"></i> Cancelar Assinaturas
                </button> -->

            </div>
        </div>
    </form>
</div>